module.exports = __webpack_public_path__ + "static/media/off.a05552fe.svg";